import { Routes } from '@angular/router';

// Guards
import { AuthGuard } from '@modules/auth/guards/auth.guard';
import { LoginGuard } from '@modules/auth/guards/login.guard';
import { ProjectGuard } from '@modules/project/guards/project.guard';
import { RecordRedirectGuard } from '@modules/records/guards/record-redirect.guard';

// Components
import { AuthComponent } from '@modules/auth/components/auth/auth.component';
import { LayoutComponent } from '@modules/layout/components/layout/layout.component';
import { RecordListComponent } from '@modules/records/components/record-list/record-list.component';
import { UsersManagementComponent } from '@modules/users/components/users-management/users-management.component';
import { ProjectDetailsComponent } from '@modules/project/components/project-details/project-details.component';
import { UserSettingsComponent } from '@modules/users/components/user-settings/user-settings.component';
import { RecordLogsComponent } from '@modules/records/components/record-logs/record-logs.component';
import { InviteComponent } from '@modules/auth/components/invite/invite.component';
import { ResetPasswordComponent } from '@modules/auth/components/reset-password/reset-password.component';
import { SettingsComponent } from '@modules/settings/components/settings/settings.component';

export const routes: Routes = [
    { path: 'invite', component: InviteComponent },
    { path: 'reset', component: ResetPasswordComponent },
    { path: 'login', component: AuthComponent, canActivate: [LoginGuard] },

    // Legacy deep links with no project segment. These must stay above ':projectId', which would
    // otherwise match 'records' as the project id.
    { path: 'records/:id/logs', redirectTo: 'records/:id' },
    { path: 'records/:id', canActivate: [AuthGuard, RecordRedirectGuard], children: [] },

    // Bare '/'. ProjectGuard normally redirects away from here; the component only ever renders
    // when the user has no projects at all. Deliberately not pathMatch 'full' on the parent — the
    // child is, so '/users' falls through to ':projectId' instead of matching here.
    {
      path: '',
      component: LayoutComponent,
      canActivate: [AuthGuard, ProjectGuard],
      children: [
        { path: '', pathMatch: 'full', component: RecordListComponent },
      ]
    },

    {
      path: ':projectId',
      component: LayoutComponent,
      canActivate: [AuthGuard, ProjectGuard],
      children: [
        { path: 'users', component: UsersManagementComponent },
        { path: 'records/:id/logs', redirectTo: 'records/:id'},
        { path: 'records/:id', component: RecordLogsComponent },
        { path: 'records', component: RecordListComponent },
        { path: 'project', component: ProjectDetailsComponent },
        { path: 'settings', component: SettingsComponent },
        { path: 'account', component: UserSettingsComponent },
        { path: '', pathMatch: 'full', redirectTo: 'records' },
        { path: '**', redirectTo: 'records' },
      ]
    },
    { path: '**', redirectTo: '' },
];
